<template>
    <div style="display:flex;flex-direction:column;flex:1;">
        <app-form
            style="flex:1;"
            v-bind:parentObject = "{
                data: this.formData,
                pageTitle: this.pageTitle,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import KpiSettingForm from '../../../components/performancemanagement/targetsetting/Form_CommonKpi';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': KpiSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('performancemanagement.editcommonkpi'),
            formData: this.$route.params,
            errMsg: '',
            isErr:false,
            editMode: false 
        }
    },
}

</script>